export const NO_PRODUCT_IMAGE = '/assets/color-logo-no-background.png';
